// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { SlTpPriceType } from '../Enums/Constants';
export class SlTpHolder {
    constructor() {
        this.StopLossPriceValue = NaN;
        this.StopLossLimitPriceValue = null; // #91413
        this.TakeProfitPriceValue = NaN;
        this.StopLossPriceType = SlTpPriceType.Absolute;
        this.TakeProfitPriceType = SlTpPriceType.Absolute;
        this.RealTrStopPrice = null; // #103539
        this.SLTPTriggerShortValue = null; // #109798
    }
    isEmpty() {
        return this.isSlEmpty() && this.isTpEmpty();
    }
    isSlEmpty() {
        return isNaN(this.StopLossPriceValue);
    }
    isTpEmpty() {
        return isNaN(this.TakeProfitPriceValue);
    }
    isSllEmpty() {
        return this.StopLossLimitPriceValue === null || isNaN(this.StopLossLimitPriceValue);
    }
    isSlAbsolute() {
        return (this.StopLossPriceType === SlTpPriceType.Absolute ||
            this.StopLossPriceType === SlTpPriceType.ProtectiveAbsolute);
    }
    isTpAbsolute() {
        return (this.TakeProfitPriceType === SlTpPriceType.Absolute ||
            this.TakeProfitPriceType === SlTpPriceType.ProtectiveAbsolute);
    }
    isTrailingStop() {
        return this.StopLossPriceType === SlTpPriceType.TrOffset;
    }
    copyFrom(sltpHolder) {
        this.StopLossPriceValue = sltpHolder.StopLossPriceValue;
        this.StopLossLimitPriceValue = sltpHolder.StopLossLimitPriceValue;
        this.TakeProfitPriceValue = sltpHolder.TakeProfitPriceValue;
        this.StopLossPriceType = sltpHolder.StopLossPriceType;
        this.TakeProfitPriceType = sltpHolder.TakeProfitPriceType;
        this.RealTrStopPrice = sltpHolder.RealTrStopPrice;
        this.SLTPTriggerShortValue = sltpHolder.SLTPTriggerShortValue;
    }
}
